// extracted by mini-css-extract-plugin
export default {"fixedContact":"_5hHIyDLez7fHOiAW5f7OXo","hiddenFixedContact":"_3m6ezVsOY7iZ85gx0oEmDu"};